import Markdown from 'markdown-to-jsx';
import { useContext } from 'react';
import { AppContext } from 'providers/AppProvider';
import { FLOW_TYPE } from 'consts';
import { RiskqTextRRSU } from './RiskqTextRRSU';

type RiskqTextProps = Readonly<{
	isLastPage: boolean;
	testType: string;
	flowType: string;
}>;

export function RiskqText(props: RiskqTextProps) {
	const { flowType, isLastPage, testType } = props;
	const { t } = useContext(AppContext);

	if (FLOW_TYPE.RR_SU === flowType) {
		return <RiskqTextRRSU />;
	}

	const suffix = isLastPage ? 'derivatives_text' : 'page_1_text';

	return (
		<Markdown className="arionui mb-5" options={{ forceBlock: true }}>
			{t(`${testType}_${suffix}`, 'testRisk')}
		</Markdown>
	);
}
